import { render, staticRenderFns } from "./DomainSettingsForm.vue?vue&type=template&id=ab04fcd6"
import script from "./DomainSettingsForm.vue?vue&type=script&lang=js"
export * from "./DomainSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab04fcd6')) {
      api.createRecord('ab04fcd6', component.options)
    } else {
      api.reload('ab04fcd6', component.options)
    }
    module.hot.accept("./DomainSettingsForm.vue?vue&type=template&id=ab04fcd6", function () {
      api.rerender('ab04fcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/domain-settings-form/DomainSettingsForm.vue"
export default component.exports